// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3R79U","buttons":"Footer_buttons__31bYt"};